import React, {
    Component
} from 'react'
import { actionTypes } from '../constants';
import _ from 'lodash';
import moment from 'moment-timezone';
import Icon from '@material-ui/core/Icon';
import EnhancedTable from '../widgets/table-enhanced'

export default class Container extends Component {
    constructor() {
        super()
        this.state = {
        }
    }

    render() {
        let report = this.props.reports.detail;
        console.log(report);

        console.log(this.state)

        let table =  (
            <EnhancedTable
                data={_.get(report, 'activities', [])}
                order='desc'
                orderBy='createdAt'
                rowsPerPage={10}
                rowClickHandler={(e, r)=>{
                    e.preventDefault();
                    console.log('rowClickHandler!')
                }}
                columns={[
                  {id: 'createdAt', label: 'Created'},
                  {id: 'text', label: 'Activity' },
                ]}
                buildTableRow={activity=>{
                    return (
                        <React.Fragment>
                            <EnhancedTable.Cell>{moment(activity.createdAt).format('MMM Do, YYYY h:mma')}</EnhancedTable.Cell>
                            <EnhancedTable.Cell>{activity.text}</EnhancedTable.Cell>
                        </React.Fragment>
                    );
                }}
            />
        )

        return (
            <React.Fragment>
                <div className="card-content">
                    <h2 className="detail-heading">
                        Activity Log
                    </h2>
                </div>
                {table}
            </React.Fragment>
        )
    }
}
